

























import { defineComponent, computed } from "@vue/composition-api";
import { alarm } from "@/store";

export default defineComponent({
    props: {
        armed: { type: Boolean, required: true }
    },
    setup(props) {
        const armedText = computed((): string => {
            return props.armed
                ? alarm.syncAlarm
                    ? "Disarming system"
                    : "System armed"
                : alarm.syncAlarm
                    ? "Arming system"
                    : "System disarmed";
        });
        const armedSubText = computed((): string => {
            return props.armed ? "Press to disarm" : "Press to arm";
        });
        const alarmSyncronising = computed(() => {
            return alarm.syncAlarm;
        });
        const toggleAlarm = () => {
            if (props.armed) {
                alarm.Disarm();
                setTimeout(() => {
                    if (props.armed) {
                        // Alarm did not disarm, try again
                        alarm.Disarm();
                    }
                }, 7000);
            } else {
                alarm.Arm();
                setTimeout(() => {
                    if (!props.armed) {
                        // Alarm did not arm, try again
                        alarm.Arm();
                    }
                }, 7000);
            }
        };
        //const toggleAlarm = () => {
        //    if (props.armed) {
        //        alarm.Disarm();
        //    } else {
        //        alarm.Arm();
        //    }
        //};
        return {
            armedText,
            armedSubText,
            toggleAlarm,
            alarmSyncronising
        };
    }
});
